export default __webpack_public_path__ + "static/media/app_icon.e4709056.png";